import {
  CREATE_VISION_REQUEST, CREATE_VISION_SUCCESS, CREATE_VISION_FAIL,
  GET_VISIONS_REQUEST, GET_VISIONS_SUCCESS, GET_VISIONS_FAIL,
  GET_VISION_REQUEST, GET_VISION_SUCCESS, GET_VISION_FAIL,
  UPDATE_VISION_REQUEST, UPDATE_VISION_SUCCESS, UPDATE_VISION_FAIL,
  DELETE_VISION_REQUEST, DELETE_VISION_SUCCESS, DELETE_VISION_FAIL,
  CREATE_NODE_REQUEST, CREATE_NODE_SUCCESS, CREATE_NODE_FAIL,
  UPDATE_NODE_REQUEST, UPDATE_NODE_SUCCESS, UPDATE_NODE_FAIL,
  DELETE_NODE_REQUEST, DELETE_NODE_SUCCESS, DELETE_NODE_FAIL,
  CREATE_CONNECTION_REQUEST, CREATE_CONNECTION_SUCCESS, CREATE_CONNECTION_FAIL,
  DELETE_CONNECTION_REQUEST, DELETE_CONNECTION_SUCCESS, DELETE_CONNECTION_FAIL,
  PLANNING_CHAT_REQUEST, PLANNING_CHAT_SUCCESS, PLANNING_CHAT_FAIL,
  ONBOARD_REQUEST, ONBOARD_SUCCESS, ONBOARD_FAIL,
  SUGGEST_NODES_REQUEST, SUGGEST_NODES_SUCCESS, SUGGEST_NODES_FAIL,
  PLANNING_CLEAR_ERRORS,
} from '../constants/planningConstants';

const initialState = {
  loading: false,
  error: null,
  visions: [],
  activeVision: null,
  // Hierarchical structure returned by getVision
  milestones: [],     // each has .actions[], each action has .subNodes[]
  connections: [],
  chatLoading: false,
  suggestedNodes: [], // AI-suggested actions for a milestone
  onboardLoading: false,
};

export const planningReducer = (state = initialState, action) => {
  switch (action.type) {
    // Loading states
    case CREATE_VISION_REQUEST:
    case GET_VISIONS_REQUEST:
    case GET_VISION_REQUEST:
    case UPDATE_VISION_REQUEST:
    case DELETE_VISION_REQUEST:
    case CREATE_NODE_REQUEST:
    case UPDATE_NODE_REQUEST:
    case DELETE_NODE_REQUEST:
    case CREATE_CONNECTION_REQUEST:
    case DELETE_CONNECTION_REQUEST:
      return { ...state, loading: true, error: null };

    case PLANNING_CHAT_REQUEST:
      return { ...state, chatLoading: true, error: null };

    case ONBOARD_REQUEST:
      return { ...state, onboardLoading: true, error: null };

    case SUGGEST_NODES_REQUEST:
      return { ...state, loading: true };

    // Visions
    case CREATE_VISION_SUCCESS:
      return { ...state, loading: false, visions: [action.payload, ...state.visions] };

    case GET_VISIONS_SUCCESS:
      return { ...state, loading: false, visions: action.payload };

    case GET_VISION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeVision: action.payload.vision,
        milestones: action.payload.milestones,
        connections: action.payload.connections,
      };

    case UPDATE_VISION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeVision: state.activeVision?._id === action.payload._id ? action.payload : state.activeVision,
        visions: state.visions.map(v => v._id === action.payload._id ? action.payload : v),
      };

    case DELETE_VISION_SUCCESS:
      return {
        ...state,
        loading: false,
        visions: state.visions.filter(v => v._id !== action.payload),
        activeVision: state.activeVision?._id === action.payload ? null : state.activeVision,
      };

    // Nodes — workspace re-fetches after mutations to keep hierarchy in sync
    case CREATE_NODE_SUCCESS:
    case UPDATE_NODE_SUCCESS:
    case DELETE_NODE_SUCCESS:
      return { ...state, loading: false };

    // Connections
    case CREATE_CONNECTION_SUCCESS:
      return { ...state, loading: false, connections: [...state.connections, action.payload] };

    case DELETE_CONNECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        connections: state.connections.filter(c => c._id !== action.payload),
      };

    // Chat
    case PLANNING_CHAT_SUCCESS:
      return { ...state, chatLoading: false };

    case ONBOARD_SUCCESS:
      return { ...state, onboardLoading: false };

    case SUGGEST_NODES_SUCCESS:
      return { ...state, loading: false, suggestedNodes: action.payload };

    // Errors
    case CREATE_VISION_FAIL:
    case GET_VISIONS_FAIL:
    case GET_VISION_FAIL:
    case UPDATE_VISION_FAIL:
    case DELETE_VISION_FAIL:
    case CREATE_NODE_FAIL:
    case UPDATE_NODE_FAIL:
    case DELETE_NODE_FAIL:
    case CREATE_CONNECTION_FAIL:
    case DELETE_CONNECTION_FAIL:
    case SUGGEST_NODES_FAIL:
      return { ...state, loading: false, error: action.payload };

    case PLANNING_CHAT_FAIL:
      return { ...state, chatLoading: false, error: action.payload };

    case ONBOARD_FAIL:
      return { ...state, onboardLoading: false, error: action.payload };

    case PLANNING_CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};
